import React from 'react'
import { useState } from 'react'
import BarChartPlot from '../diagrams/Barchart'
import './Dashboards.css'
import endpoints from '../endpoints.json'
import DateFilter from './DateFilter'
import { useEffect } from 'preact/hooks'

function createOptions(values) {
  console.log('Values:', values)
  var options = []
  for (let i = 0; i < values.length; i++) {
    var col = { value: values[i], text: values[i] }
    options.push(col)
  }
  return options
}

const CheckboxFilter = ({ column, graphConf, setGraphConf, setGraphData }) => {
  const [checked, setChecked] = useState([])
  const [values, setValues] = useState([])

  useState(() => {
    console.log('Column:', column)
    setValues(createOptions(column.values))
    setChecked(column.filter.values)
    console.log('Options:', createOptions(column.values))
    console.log('Checked:', column.filter.values)
  }, [])

  const handleCheckbox = async (event) => {
    console.log('Checkbox:', event.target.value)

    var temp = event.target.value
    if (temp.length === 0) {
      temp = column.values.filter((value) => value !== null)
      console.log(temp)
    }
    setChecked(temp)
    column.filter = { operator: column.filter.operator, values: temp, typ: 'discrete' }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    //setGraphConf(tempGraphConf)

    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  return (
    <div>
      <one-ux-checkbox-group
        label="Choose values"
        columns="2"
        options={values}
        value={checked}
        onChange={handleCheckbox}></one-ux-checkbox-group>
    </div>
  )
}

const DateGraphFilter = ({ column, graphConf, setGraphConf, setGraphData }) => {
  const [from, setFrom] = useState(column.filter.values[0])
  const [to, setTo] = useState(column.filter.values[1])
  const [error, setError] = useState(false)

  const isValidDate = (input) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/
    if (!regex.test(input)) {
      return false
    }

    const [year, month, day] = input.split('-').map(Number)
    const date = new Date(year, month - 1, day)
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
  }

  const handleDateFrom = async (t_from) => {
    setError(false)
    if (!isValidDate(t_from) && t_from !== '') {
      setError(true)
      return
    }
    if (from === '') {
      t_from = '1970-01-01'
    }

    let t_to = '2100-01-01'
    if (column.filter) {
      t_to = column.filter.values[1]
    }

    column.filter = { operator: 'BETWEEN', values: [t_from, t_to], typ: 'date' }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    setGraphConf(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  const handleDateTo = async (t_to) => {
    setError(false)
    if (!isValidDate(t_to) && t_to !== '') {
      setError(true)
      return
    }
    if (to === '') {
      t_to = '2100-01-01'
    }

    let t_from = '1970-01-01'
    if (column.filter) {
      t_from = column.filter.values[0]
    }

    column.filter = { operator: 'BETWEEN', values: [t_from, t_to], typ: 'date' }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    setGraphConf(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }
  return (
    <div className="date-box">
      {error && <p>Something went wrong with the input please correct the format</p>}
      <one-ux-field label="Date" compact={true}>
        <DateFilter
          to={column.filter.values[1]}
          handleTo={handleDateTo}
          from={column.filter.values[0]}
          handleFrom={handleDateFrom}></DateFilter>
      </one-ux-field>
      {/* <one-ux-button
        class="structure-button"
        label="Update"
        purpose="defualt"
        weight="normal"
        onClick={handleDate}></one-ux-button> */}
    </div>
  )
}

const NumBoxFilter = ({ column, graphConf, setGraphConf, setGraphData }) => {
  const [operator, setOperator] = useState(column.filter.operator)
  const handleNumericChange = async (event) => {
    console.log('Value:', event.target.value)
    column.filter = { operator: operator, values: [event.target.value], typ: 'num' }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    setGraphConf(tempGraphConf)
    console.log(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  return (
    <div>
      <one-ux-field label={column.alias + ' ' + column.filter.operator}>
        <one-ux-input
          width="4/12"
          onChange={handleNumericChange}
          value={column.filter.values[0]}
          placeholder="Input numeric value"></one-ux-input>
      </one-ux-field>
    </div>
  )
}

const DropdownFilter = ({ column, graphConf, setGraphData, setGraphConf }) => {
  const handleChangeValue = async (event) => {
    console.log('Value:', event.target.value)

    var temp = event.target.value
    if (temp.length === 0) {
      temp = column.values.filter((value) => value !== null)
      console.log(temp)
    }

    column.filter = {
      operator: column.filter.operator,
      values: temp,
      typ: 'discrete',
      locked: column.filter.locked
    }

    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    console.log(tempGraphConf)
    setGraphConf(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  useEffect(() => {
    console.log('Column:', column)
  }, [])

  return (
    <one-ux-field label={column.filter.operator === 'NOT IN' ? column.alias + ' (Not in)' : column.alias} width="2/12">
      <one-ux-dropdown placeholder={'Value'}>
        <one-ux-list
          multiple
          options={createOptions(column.values)}
          value={column.filter.values}
          onInput={handleChangeValue}></one-ux-list>
      </one-ux-dropdown>
    </one-ux-field>
  )
}

const Graph = ({ graphData, graphConf, setGraphConf, setGraphData, onDelete, onEdit }) => {
  const handleDelete = () => {
    onDelete?.()
  }

  const handleEdit = () => {
    onEdit?.()
  }

  return (
    <div className="graph-card">
      {
        <div className="graph-header">
          <one-ux-text class="graph-text">{graphConf.name}</one-ux-text>
          <div className="grap-icons">
            {onEdit && (
              <div className="graph-info-icon" style={{ cursor: 'pointer' }} onClick={handleEdit}>
                <one-ux-icon class="user-info-2" icon="edit" set="default" size="400"></one-ux-icon>
                <div className="tooltip-graph-info">
                  <p>{'Edit graph'}</p>
                </div>
              </div>
            )}
            {onDelete && (
              <div className="graph-info-icon" style={{ cursor: 'pointer' }} onClick={handleDelete}>
                <one-ux-icon class="user-info-2" icon="delete" set="default" size="400"></one-ux-icon>
                <div className="tooltip-graph-info">
                  <p>{'Delete graph'}</p>
                </div>
              </div>
            )}

            <div className="graph-info-icon">
              <one-ux-icon class="user-info-2" icon="info" set="default" size="400"></one-ux-icon>
              <div className="tooltip-graph-info">
                <p>{graphConf.description}</p>
              </div>
            </div>
          </div>
        </div>
      }
      <div className="graph-content">
        <div className="graph-filters">
          {graphConf.columns
            .filter((col) => col.filter !== null && !col.filter.locked)
            .map((col2) => {
              return col2.filter.typ === 'discrete' ? (
                <DropdownFilter
                  column={col2}
                  graphConf={graphConf}
                  setGraphConf={setGraphConf}
                  setGraphData={setGraphData}></DropdownFilter>
              ) : col2.filter.typ === 'num' ? (
                <NumBoxFilter
                  column={col2}
                  graphConf={graphConf}
                  setGraphConf={setGraphConf}
                  setGraphData={setGraphData}></NumBoxFilter>
              ) : (
                <DateGraphFilter
                  column={col2}
                  graphConf={graphConf}
                  setGraphConf={setGraphConf}
                  setGraphData={setGraphData}></DateGraphFilter>
              )
            })}
        </div>

        {/* <div className="graph-filters">
          {graphConf.columns
            .filter((col) => col.filter !== null && !col.filter.locked)
            .map((col2) => {
              return (
                <div>
                  <h2>{col2.alias}</h2>
                  {col2.filter.typ === 'discrete' ? (
                    <CheckboxFilter
                      column={col2}
                      graphConf={graphConf}
                      setGraphConf={setGraphConf}
                      setGraphData={setGraphData}
                    />
                  ) : col2.filter.typ === 'date' ? (
                    <DateGraphFilter
                      column={col2}
                      graphConf={graphConf}
                      setGraphConf={setGraphConf}
                      setGraphData={setGraphData}
                    />
                  ) : col2.filter.typ === 'num' ? (
                    <NumBoxFilter
                      column={col2}
                      graphConf={graphConf}
                      setGraphConf={setGraphConf}
                      setGraphData={setGraphData}
                    />
                  ) : null}
                </div>
              )
            })}
        </div> */}
        <div className="graph-graph">
          {graphData.keys.length > 0 ? (
            <BarChartPlot json={graphData} style={{ width: '200px', margin: '10px' }} />
          ) : (
            <p>No data</p>
          )}
        </div>
      </div>
    </div>
  )
}
export default Graph
